import React, { Fragment } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  BulkDeleteButton,
  BulkDeleteButtonProps,
  ListProps,
  SelectInput,
} from "react-admin";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { statusList } from "./conts";
import { availableOnlySuperAdminAndAdminAndFinance } from "utils/tools";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ListEditButton from "../../components/ListEditButton";
import ActionsMenu from "../../components/ActionsMenu";

const BulkActionButtons = (props: BulkDeleteButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

const CompanyFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const CompanyList = (props: ListProps) => {
  const breadcrumb = [{ link: "/companies", title: "Companies" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Companies"
        isNotHaveSchoolFilter
        exporter={false}
        filters={<CompanyFilter />}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={<BulkActionButtons />}
        {...props}
        hasCreate={availableOnlySuperAdminAndAdminAndFinance()}
      >
        <Datagrid>
          <FunctionField
            label="Company Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>
                  <TextField source="id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <TextField source="name" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="user.email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="mobile" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mbc Code :
                  </Typography>
                  <TextField source="user.mbcCustomerId" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Personal In Charge Info"
            render={(record: any) => (
              <>
                {record.personInCharges && (
                  <SanitizedGrid container spacing={2}>
                    {record.personInCharges.length > 0 ? (
                      <>
                        {record.personInCharges.map(
                          (personInCharge: IParent, index: number) => {
                            return (
                              <>
                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2">
                                    Id : {personInCharge.id}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2">
                                    Name : {personInCharge.firstName}{" "}
                                    {personInCharge.lastName}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2" style={GridLabel}>
                                    Email : {personInCharge.user?.email}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2" style={GridLabel}>
                                    Mobile : {personInCharge.mobile}
                                  </Typography>
                                </Grid>

                                {record.personInCharges.length - 1 !==
                                  index && (
                                  <Grid item xs={12}>
                                    <Divider />
                                  </Grid>
                                )}
                              </>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <Typography variant="body2">-</Typography>
                        </Grid>
                      </>
                    )}
                  </SanitizedGrid>
                )}
              </>
            )}
          />
          <CustomDateField source="createdAt" emptyText="-" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  <ListShowButton record={record} />,
                  availableOnlySuperAdminAndAdminAndFinance() && (
                    <ListEditButton record={record} />
                  ),
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default CompanyList;
